import { Mesh } from "three";
import { logger } from "../../../util/Logger";
import { glassMaterial } from "./Materials";
import { RailPart } from "./RailPart";
import { RailPartOptions } from "./RailPartOptions";
import { createBox } from "./utils";

export class RailGlassPart extends RailPart {
  constructor(width: number, options: Partial<RailPartOptions> = {}) {
    super(width, options);
  }

  private _glass?: Mesh;

  protected createRailMeshes() {
    logger.debug("RailGlassPart width", this._width);
    logger.debug("RailGlassPart createRailMeshes", this._options);

    this._glass = createBox(
      {
        width: this._width,
        height: this._options.railHeight,
        depth: this._options.railDepth * 0.1,
      },
      glassMaterial
    ) as Mesh;
    this._glass.position.set(0, this._options.bottomOffset, 0);

    this._glass.name = "glass_rail_name";
    this.add(this._glass);
  }

  dispose() {
    super.dispose();
    this._glass?.removeFromParent();
    this._glass?.geometry?.dispose();
    (this._glass?.material as any)?.dispose();
    logger.debug("RailGlassPart disposed", this._glass);
  }
}
